// Copyright (c) Docugami, Inc. All rights reserved.

import { WordTaskpane } from '../components/assisted_authoring/WordTaskpane';
import { useSelector } from 'react-redux';
import { AppState } from '../store';
import { useDeepLinkInitializer } from '../hooks/deepLinkInitializer';
import { WordDiagnosticsPane } from '../test/wordTaskPaneAddin/src/components/WordDiagnosticsPane';
import { useDocumentDgmlContext, DocumentDgmlContext } from 'hooks/documentDgml';
import { useGetLabelsQuery } from 'store/frontend/frontendSlice';

export const DocumentPage = (): JSX.Element => {
    const [, context] = useDeepLinkInitializer();

    const showWordTestTaskpane = useSelector((state: AppState) => state.settings.assistedAuthoring.showWordTestTaskpane);
    const documentsIndexed = useSelector((state: AppState) => Object.keys(state.documents.indexed).length > 0);
    const dgmlContext = useDocumentDgmlContext(context.documentId);
    useGetLabelsQuery(context.clusterId);

    function getContents(): JSX.Element {
        if (!(window as any)._OfficeMode || !context.documentId || !documentsIndexed) {
            return <div />
        }

        if (showWordTestTaskpane) {
            // We're in Office but Eric wants his test taskpane to show
            return <WordDiagnosticsPane />
        } else {
            // We're in Office for real
            return (
                <div style={{ width: "100%" }}>
                    <WordTaskpane documentId={context.documentId} />
                </div>
            )
        }
    }

    return (
        <DocumentDgmlContext.Provider value={dgmlContext}>
            {getContents()}
        </DocumentDgmlContext.Provider>
    )
}
